<template>
  <div v-if="demoType === 'trial'" class="trial-control-container">
    <!-- 过期 -->
    <div v-if="expiredTrialAccount" :class="{ 'is-unfold': isUnfold }" class="trial trial-expired">
      <span class="status">Expired</span>
    </div>
    <div v-else-if="isUnfold">
      <AppLink
        v-if="$checkPermission(['admin', 'diamond'])"
        to="/setting/subscription-and-billing-v2/billing"
        :class="isPaymentFailed?'trial-unfold payment-failed':'trial-unfold'"
      >
        <span v-if="!isPaymentFailed" class="status">{{ timeLeft }} left in Trial</span>
        <span v-else class="status">Payment Failed</span>
        <span class="buy-btn">
          Check
          <svg-icon class="buy-icon" name="ic-left-more"></svg-icon>
        </span>
      </AppLink>
      <div v-else :class="isPaymentFailed?'trial-unfold payment-failed':'trial-unfold'">
        <span v-if="!isPaymentFailed" class="status">{{ timeLeft }} left in Trial</span>
        <span v-else class="status">Payment Failed</span>
      </div>
    </div>
    <div v-else :class="isPaymentFailed?'trial trial-closure payment-failed':'trial trial-closure'">
      <span v-if="!isPaymentFailed" class="status">Trial</span>
      <span v-else class="status">Fai.</span>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import AppLink from './link.vue'
export default {
  name: 'TrialControl',
  components: { AppLink },
  props: {
    isUnfold: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      demoType: state => state.user.demoType,
      expireDate: state => state.user.expireDate,
      expiredTrialAccount: state => state.user.expiredTrialAccount
    }),
    timeLeft() {
      let interval = (new Date(this.expireDate).getTime() - Date.now()) / (24 * 60 * 60 * 1000)
      interval = Math.round(interval);
      if (interval > 1) return `${interval} days`;
      return `${interval} day`;
    },
    isPaymentFailed(){
      let interval = (new Date(this.expireDate).getTime() - Date.now()) / (24 * 60 * 60 * 1000)
      interval = Math.round(interval);
      return (interval <0 )
    }
  },
}
</script>
<style lang="scss" scoped>
.trial-control-container {
  // margin-top: 12px;
  width: 100%;
  height: 36px;
  padding: 0 12px 10px;
  background: #001c4f;
  .trial {
    padding: 5px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    .status {
      font-family: OpenSans-Bold, sans-serif;
      font-size: 12px;
      color: #fff;
    }
  }
  .trial-expired {
    margin: 0 -7px;
    background-color: #cc581d;
    &.is-unfold {
      margin: 0;
    }
  }
  .trial-closure {
    background-color: #0abc4e;
  }
  .trial-unfold {
    padding: 5px 10px;
    display: flex;
    align-items: center;
    border-radius: 5px;
    background-color: #0abc4e;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: none;
    .status {
      flex: 1;
      font-family: OpenSans-Bold, sans-serif;
      font-size: 12px;
      color: #fff;
    }
    .buy-btn {
      flex-shrink: 0;
      margin-left: 5px;
      display: flex;
      align-items: center;
      font-family: OpenSans-Bold, sans-serif;
      font-size: 12px;
      color: #fff;
      .buy-icon {
        flex-shrink: 0;
        font-size: 12px;
      }
    }
  }
  .payment-failed {
    background-color:#CF1322
  }
}
</style>
